/**
 * Shared status tone surfaces for the pill canon (RD-UI-030 / KAN-631).
 *
 * Warning + danger TEXT use the Strong tokens so 12px copy passes contrast on
 * the soft wash. Fills and borders stay on the normal Soft / Border ramps.
 * `icon` keeps the vivid non-Strong hue for glyphs and dots.
 */

import { foundation } from './tokens';

const { color } = foundation;
const sem = color.semantic;
const neu = color.neutral;

/** @typedef {'neutral'|'success'|'warning'|'danger'|'info'|'operations'|'violet'} StatusTone */

const TONES = {
  neutral: {
    fg: neu.textMuted,
    bg: neu.surfaceMuted,
    border: neu.border,
    icon: neu.textMuted,
  },
  success: {
    fg: sem.success,
    bg: sem.successSoft,
    border: sem.successBorder,
    icon: sem.success,
  },
  warning: {
    fg: sem.warningStrong,
    bg: sem.warningSoft,
    border: sem.warningBorder,
    icon: sem.warning,
  },
  danger: {
    fg: sem.dangerStrong,
    bg: sem.dangerSoft,
    border: sem.dangerBorder,
    icon: sem.danger,
  },
  info: {
    fg: sem.info,
    bg: sem.infoSoft,
    border: sem.infoBorder,
    icon: sem.info,
  },
  operations: {
    fg: sem.operations,
    bg: sem.operationsSoft,
    border: sem.operationsBorder,
    icon: sem.operations,
  },
  violet: {
    fg: sem.violet,
    bg: sem.violetSoft,
    border: sem.violetBorder,
    icon: sem.violet,
  },
};

/** @param {string} [tone] */
export function getStatusTone(tone) {
  return TONES[tone] || TONES.neutral;
}

/** Soft-fill pill chrome for a tone (contrast-safe text). */
export function statusTonePillStyle(tone) {
  const { fg, bg, border } = getStatusTone(tone);
  return {
    backgroundColor: bg,
    color: fg,
    border: `1px solid ${border}`,
  };
}
